import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShoppingBag, Menu, X, User } from "lucide-react";
import Logo from "./Logo";
import { useApp } from "../context/AppContext";

const links = [
  { to: "/", key: "home" },
  { to: "/catalogue", key: "catalog" },
  { to: "/produits", key: "products" },
  { to: "/atelier", key: "atelier" },
];

export default function Navbar() {
  const { cartCount, customer } = useApp();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-cream/80 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 md:px-10">
        <Logo />
        <div className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.key}`}
              className={`link-underline text-sm uppercase tracking-widest ${
                loc.pathname === l.to ? "text-ink" : "text-ink2"
              }`}
            >
              {t(`nav.${l.key}`)}
            </Link>
          ))}
        </div>
        <div className="flex items-center gap-4">
          <Link
            to="/compte"
            data-testid="nav-account"
            title="Mon compte"
            className={`relative flex h-10 w-10 items-center justify-center rounded-full border transition-colors hover:bg-sand ${customer && customer.user_id ? "border-terra text-terra" : "border-line"}`}
          >
            <User className="h-[18px] w-[18px]" strokeWidth={1.5} />
          </Link>
          <Link
            to="/panier"
            data-testid="nav-cart"
            className="relative flex h-10 w-10 items-center justify-center rounded-full border border-line transition-colors hover:bg-sand"
          >
            <ShoppingBag className="h-[18px] w-[18px]" strokeWidth={1.5} />
            {cartCount > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-terra text-[10px] font-medium text-white"
              >
                {cartCount}
              </span>
            )}
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-line md:hidden"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="border-t border-line bg-cream px-5 py-4 md:hidden">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block py-3 text-sm uppercase tracking-widest text-ink2"
            >
              {t(`nav.${l.key}`)}
            </Link>
          ))}
          <Link to="/compte" onClick={() => setOpen(false)} className="block py-3 text-sm uppercase tracking-widest text-ink2">{t("nav.account")}</Link>
        </div>
      )}
    </header>
  );
}
